import gql from 'graphql-tag'
import React, { useState } from 'react'
import { ActivityIndicator, TextInput } from 'react-native'
import Spacer from 'react-spacer'
import { Text, VStack } from 'react-stacked'

import { useSendMarketingPushNotificationMutation } from '../../types/graphql'
import { PrimaryButton } from '../components/Buttons'
import Layout from '../components/Layout'
import logError from '../util/logError'
import useNavigation from '../util/useNavigation'

gql`
  mutation SendMarketingPushNotification($whiteLabelId: ID!, $message: String!) {
    sendMarketingPushNotification(whiteLabelId: $whiteLabelId, message: $message) {
      id

      userCount
    }
  }
`

const MarketingPushNotificationCreate: React.FC = () => {
  const [, { whiteLabelId }] = useNavigation<'MarketingPushNotificationCreate'>()
  const [message, setMessage] = useState('')
  const [sendMarketingPushNotification, { data, error, loading }] = useSendMarketingPushNotificationMutation({ variables: { whiteLabelId, message } })

  return (
    <Layout title='Pushnotiser'>
      {loading
        ? <ActivityIndicator />
        : error != null
        ? <Text>{String(error)}</Text>
        : data != null
        ? <Text>Skickade pushnotis till {data.sendMarketingPushNotification?.userCount} användare</Text>
        : (
          <VStack maxWidth={480} padding={20}>
            <Text>Använd denna funktion för att skicka en pushnotis till alla användare som handlat i din app.</Text>

            <Spacer height={24} />

            <TextInput
              multiline
              numberOfLines={5}
              onChangeText={setMessage}
              placeholder='I helgen har vi 20% på hela menyn, använd rabattkoden "PIZZA" i appen'
              style={{ borderWidth: 1, padding: 12 }}
              value={message}
            />

            <Spacer height={24} />

            <PrimaryButton
              disabled={message === ''}
              onPress={() => {
                sendMarketingPushNotification().catch(logError)
              }}
              title='Skicka'
            />
          </VStack>
        )}
    </Layout>
  )
}

export default MarketingPushNotificationCreate
